import { helper } from '@ember/component/helper';

import { syncState } from 'rise-ui/utils/sync-state.js';

export default helper(function syncStateHelper([ state, defaultValue, errorValue = syncState.UNSET ]) {
  return syncState(state, defaultValue, errorValue);
});
